import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import type { AITrafficParamsDefinition } from "./AITrafficRoutes.types";

export const params: AITrafficParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: "6m",
    },
    webSource: {
        type: "string",
        value: devicesTypes.TOTAL,
    },
    country: {
        type: "string",
        array: false,
        value: WORLDWIDE_COUNTRY_ID.toString(),
    },
    isWWW: {
        type: "string",
        value: "*",
    },
} as const;

export const ROUTES = {
    overview: "aitraffic.frame.overview",
} as const;
